import axios from '@/utils/axios';

export default {
    listStatistical (params) {
        let url = `/organization/statistic`;
        return axios({
            url: url, params: params
        })
    },
    downloadCsv(params) {
        let url = `/organization/statistic`;
        return axios({
            url: url, params: params
        })
    },
};